import { useEffect, useRef, useState } from 'react';
import { renderGuestQrDataUrl } from './guestQrCode';
import './ReportPdfQrInline.css';

/** Auto-generate and show a download QR (no session fields or extra CTA). */
export default function ReportPdfQrInline({
  createDownloadUrl,
  enabled = true,
  title = 'Scan to download PDF',
  subtitle = '',
}) {
  const createRef = useRef(createDownloadUrl);
  const [qrDataUrl, setQrDataUrl] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  createRef.current = createDownloadUrl;

  useEffect(() => {
    if (!enabled || typeof createRef.current !== 'function') {
      setQrDataUrl('');
      setError('');
      return undefined;
    }
    let cancelled = false;
    (async () => {
      setBusy(true);
      setError('');
      setQrDataUrl('');
      try {
        const url = await createRef.current();
        if (cancelled || !url) throw new Error('PDF link unavailable');
        const dataUrl = await renderGuestQrDataUrl(url, 220);
        if (!cancelled) setQrDataUrl(dataUrl);
      } catch (e) {
        if (!cancelled) setError(e?.message || 'Could not prepare PDF QR');
      } finally {
        if (!cancelled) setBusy(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  if (!enabled) return null;

  return (
    <div className="report-pdf-qr-inline" data-pdf-exclude="true">
      <p className="report-pdf-qr-inline__title">{title}</p>
      {subtitle ? <p className="report-pdf-qr-inline__sub">{subtitle}</p> : null}
      <div className="report-pdf-qr-inline__frame" aria-busy={busy}>
        {busy ? <span className="report-pdf-qr-inline__status">Preparing QR…</span> : null}
        {!busy && qrDataUrl ? (
          <img src={qrDataUrl} alt="" className="report-pdf-qr-inline__img" />
        ) : null}
        {!busy && !qrDataUrl && !error ? (
          <span className="report-pdf-qr-inline__status">QR unavailable</span>
        ) : null}
      </div>
      {error ? <p className="report-pdf-qr-inline__error">{error}</p> : null}
    </div>
  );
}
